import React from 'react';
import PageHeader from '../components/layout/PageHeader';
import HubSectionCard from '../components/cards/HubSectionCard';
import hubs from '../cms/hubs.json';
import '../css/pages/About.css';

const About = () => {
  const hub = hubs.about || {};
  const aboutSections = hub.cards || [];

  return (
    <>
      <PageHeader 
        title={hub.pageTitle} 
        subtitle={hub.pageSubtitle}
        showLogo={true}
      />
      
      <div className="about-container">
        <section className="about-sections">
          <div className="sections-grid">
            {aboutSections.map((section) => (
              <HubSectionCard key={section.path || section.externalUrl || section.title} card={section} />
            ))}
          </div>
        </section>
      </div>
    </>
  );
};

export default About;